module.exports = __webpack_public_path__ + "static/media/special-mode.94b04e57.png";